import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC6VLqcQbFfJB8jFJcYIJ4_6253T5tH6CQ",
    authDomain: "clone-993fd.firebaseapp.com",
    projectId: "clone-993fd",
    storageBucket: "clone-993fd.firebasestorage.app",
    messagingSenderId: "541323967555",
    appId: "1:541323967555:web:471e07486f10ddad7168f6",
    measurementId: "G-E5865YSYCZ"
  };


  const app = initializeApp(firebaseConfig);
  export const auth = getAuth(app);
